import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { useApi } from "@/lib/api";
import { ArticleCard } from "./ArticleCard";

export const ArticleLibrary = ({ hub }) => {
  const [q, setQ] = useState("");
  const [debounced, setDebounced] = useState("");
  const [category, setCategory] = useState("");
  const { data: categories } = useApi(`/categories?hub=${hub}`);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q), 250);
    return () => clearTimeout(t);
  }, [q]);
  const params = new URLSearchParams({ hub, ...(category && { category }), ...(debounced && { q: debounced }) });
  const { data: articles, loading } = useApi(`/articles?${params}`);

  const chip = (active) => `rounded-full px-4 py-2 min-h-[44px] text-sm font-semibold border transition-colors ${active ? "bg-ink text-cream border-ink" : "bg-white/70 border-ink/10 hover:border-ink/40"}`;

  return (
    <section className="container-site" aria-label="Article library">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-center justify-between mb-8">
        <label className="relative w-full lg:max-w-md">
          <span className="sr-only">Search articles</span>
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-ink-muted" aria-hidden="true" />
          <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search, e.g. boundaries, relapse, money" className="field pl-12 rounded-full" data-testid={`${hub}-search-input`} />
        </label>
        <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by category">
          <button type="button" className={chip(!category)} aria-pressed={!category} onClick={() => setCategory("")} data-testid={`${hub}-filter-all`}>All</button>
          {(categories || []).map((c) => (
            <button key={c.slug} type="button" className={chip(category === c.slug)} aria-pressed={category === c.slug} onClick={() => setCategory(c.slug)} data-testid={`${hub}-filter-${c.slug}`}>{c.name}</button>
          ))}
        </div>
      </div>
      <p className="sr-only" aria-live="polite">{loading ? "Loading articles" : `${(articles || []).length} articles found`}</p>
      {!loading && articles?.length === 0 && (
        <div className="card-soft p-8 text-ink-soft" data-testid={`${hub}-no-results`}>No articles match that search yet. Try a different word, or browse all topics.</div>
      )}
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid={`${hub}-article-grid`}>
        {(articles || []).map((a) => <ArticleCard key={a.slug} article={a} />)}
      </div>
    </section>
  );
};
